import React from 'react';
import ArticleCardsData from './ArticleCardsData';

const ArticleCardsRenderer = ({ articleCards }) =>
  articleCards.map((articleCard, index) => {
    const { __typename: cardBlockName, ...cardData } = articleCard;
    const blockNameParts = cardBlockName.split('_');
    const componentKey = blockNameParts[1];
    const ArticleCard = ArticleCardsData[componentKey];

    if (ArticleCard) {
      const CardBlock =
        cardData.customDisplayType && componentKey !== 'c12'
          ? ArticleCard.component[cardData.customDisplayType]
          : ArticleCard.component;

      return (
        <CardBlock
          key={`${cardBlockName}-${index}`}
          data={cardData}
          endCard={index === articleCards.length - 1}
        />
      );
    }

    return null;
  });

export default ArticleCardsRenderer;
